import { render } from "./serviceModal.vue?vue&type=template&id=7c0fabaf&scoped=true"
import script from "./serviceModal.vue?vue&type=script&lang=js"
export * from "./serviceModal.vue?vue&type=script&lang=js"

import "./serviceModal.vue?vue&type=style&index=0&id=7c0fabaf&lang=scss&scoped=true"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0fabaf"]])

export default __exports__